import {useLocation} from 'react-router-dom';
import React, {ReactNode, useEffect, useState} from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import {text} from '../text';
import {hooks} from '../hooks';
import {utils} from '../utils';
import {theme} from '../constants';
import {components } from '../components';
import { BottomSheet } from "../components/modals/BottomSheet";
import { useApp } from '../contexts/AppContext';
import Https from '../utils/apiUtility';
import AvatarContainer from '../components/Avatar';



// DTOs diretamente dentro do arquivo
interface ProfileDto {
  canal: string;
  avatar: string;
  bio: string[];
  description: string;
}

interface AffiliateDto {
  affiliateName: string;
  productName: string;
  profile: ProfileDto;
}



const onboarding = [
  {
    id: 1,
    title1: 'Bem vindo ao VidaAtiva App',
    //title2: 'bank app!',
    image: require('../assets/onboarding/1.png'),
    description:
      'A assinatura que cuida de você!!!',
  },
  {
    id: 2,
    title1: 'Bem vindo ao VidaAtiva App',
    //title2: 'few clicks!',
    image: require('../assets/onboarding/2.png'),
    description:
      'A assinatura que cuida de você!!!',
  },
  {
    id: 3,
    title1: 'Bem vindo ao VidaAtiva App',
    //title2: 'over the world!',
    image: require('../assets/onboarding/3.png'),
    description:
      'A assinatura que cuida de você!!!',
  },
];

// Função para extrair as iniciais do nome do afiliado
const getInitials = (name: string): string => {
  const words = name.split(" ");
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
};

export const Onboarding: React.FC = () => {
  const location = useLocation();
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const { setIsPrivacyOpen, setCoverage } = useApp();
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }); // Loop ativado

  const [affiliate, setAffiliate] = useState<AffiliateDto | null>(null);

  

  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (location.pathname.includes('Onboarding')) {
      metaThemeColor?.setAttribute('content', '#040325');
    } else {
      metaThemeColor?.setAttribute('content', '#ffffff');
    }
  }, [location]);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', handleSlideChange);

      // Criando o autoplay do slider a cada 3 segundos
      const interval = setInterval(() => {
        if (emblaApi) {
          emblaApi.scrollNext(); // Passa para o próximo slide
        }
      }, 4000);

      return () => clearInterval(interval); // Cleanup do intervalo ao desmontar
    }
  }, [emblaApi]);


  useEffect(() => {
    const fetchAffiliateData = async () => {
      try {
        const affiliateResponse = await Https.get("/affiliates/a0ce48ce-3a10-4ccc-8094-9ec7119e54fd");
        const affiliateData = affiliateResponse.data;

        const linkResponse = await Https.get("/affiliate-links/UPDQ-Aelv-Wadm");
        const linkData = linkResponse.data;

        const updatedAffiliate: AffiliateDto = {
          affiliateName: affiliateData.affiliate_name,
          productName: linkData.product_name || "Game Assist",
          profile: {
            ...affiliateData.profile,
            avatar: affiliateData.profile.avatar || `https://placehold.co/400?text=${getInitials(affiliateData.affiliate_name)}&font=roboto`,
          },
        };

        setAffiliate(updatedAffiliate);
      } catch (error) {
        console.error("Erro ao buscar informações do afiliado:", error);
      }
    };

    fetchAffiliateData();
  }, []);


  const handleOpenBottomSheet = () => {
    if (affiliate) {
      setCoverage(affiliate);
      setIsPrivacyOpen(true);
    }
  };

  const renderPartnerBio = (): JSX.Element | null => {
    if (!affiliate) return null;

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px 4px 16px',
          margin: '18px 18px 1px 18px',
          borderRadius: '12px',
        }}
        onClick={handleOpenBottomSheet}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '40px',
          }}
        >
          <AvatarContainer avatar={affiliate.profile.avatar}/>
          <text.T14
            style={{ fontWeight: 'bold', color: '#FFF', textAlign: 'center', letterSpacing: '1.5px', marginTop: "5px" }}
          >
            {affiliate.affiliateName}
          </text.T14>
        </div>

        <div style={{ flex: 1 }}>
          <text.H4 style={{ fontWeight: 'bold', color: '#FFF', marginBottom: '3px', letterSpacing: '1.0px' }}>
            {affiliate.productName}
          </text.H4>
          {affiliate.profile.bio.map((line, index) => (
            <text.T16 key={index} style={{ color: "#FFF", marginBottom: "1.8px", lineHeight: "1.3" }}>
              {line}
            </text.T16>
          ))}
        </div>
      </div>
    );
  };


  const linhaHorizontal = (): JSX.Element => {
    return (
      <div
        style={{
          width: '100%',
          height: '0.15px',
          backgroundColor: '#3a4f90',
          marginTop: '10px',
          marginBottom: '10px',
        }}
      ></div>
    );
  };

  const renderSlider = (): JSX.Element => {
    return (
      <div
        className='embla'
        ref={emblaRef}
        style={{
          position: 'relative',
          height: '100%',
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className='embla__container'>
          {onboarding.map((item: any, index: any, array: any) => {
            return (
              <div
                key={item.id}
                style={{
                  width: '100%',
                  cursor: 'pointer',
                }}
                className='embla__slide'
              >
                <img
                  src={item.image}
                  alt='Carousel'
                  style={{
                    maxWidth: 900,
                    width: '70%',
                    margin: '0 auto',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0px 8px 10px rgba(0, 0, 0, 1.0))', // Sombra com drop-shadow
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderTitle = (): JSX.Element => {
    return (
      <div style={{marginBottom: 14, marginLeft: 20, marginRight: 20}}>
        <text.H1
          style={{
            color: theme.colors.white,
            textAlign: 'left',

            whiteSpace: 'pre-line',
          }}
        >
          {onboarding[activeIndex].title1}
        </text.H1>
        {/* <text.H1
          style={{
            color: theme.colors.white,
            textAlign: 'left',
            whiteSpace: 'pre-line',
          }}
        >
          {onboarding[activeIndex].title2}
        </text.H1> */}
      </div>
    );
  };

  const renderDescription = (): JSX.Element => {
    return (
      <div style={{marginLeft: 20, marginBottom: '8%'}}>
        <text.T16
          style={{
            textAlign: 'left',
            whiteSpace: 'pre-line',
            color: '#B4B4C6',
          }}
        >
          {onboarding[activeIndex].description}
        </text.T16>
      </div>
    );
  };

  const renderDots = (): JSX.Element => {
    return (
      <div
        className='container'
        style={{...utils.rowCenter({gap: 10}), marginBottom: '8%'}}
      >
        {onboarding.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          return (
            <div
              key={item.id}
              style={{
                backgroundColor: isSelected ? theme.colors.white : '#4F4F66',
                width: 20,
                height: 2,
                borderRadius: 4,
              }}
            />
          );
        })}
      </div>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <components.Button
        title='Começar'
        colorScheme='light'
        containerStyle={{
          width: '44%',
          margin: '0 20px 20px 20px',
        }}
        onClick={() => navigate('/SignIn')}
      />
    );
  };

  return (
    <div
      id='screen'
      style={{backgroundColor: theme.colors.mainDark}}
    >
      {renderPartnerBio()} {/* Perfil do influenciador */}
      {/* {linhaHorizontal()} */}
      <BottomSheet />
      {renderSlider()}
      {renderTitle()}
      {renderDescription()}
      {renderDots()}
      {renderButton()}
    </div>
  );
};
